import { ApiCore } from './utilities/core'


export const scorecardsAPI = (tenantSlug: string) => {
    return new ApiCore({
        getAll: true,
        getSingle: true,
        put: true,
        url: `api/${tenantSlug}/scorecards`
    })
};